import { useReducer } from 'react';
import { configs } from '../constants/configs/configs';


import { api } from '../modules/common-utils-services/axiosUtil';


const actions = {
    GET_USER_DETAILS : 'GET_USER_DETAILS',
    RESET_FORM : 'RESET_FORM',
    POST_SECURITY_ANSWER_SUCCESS : 'POST_SECURITY_ANSWER_SUCCESS',
    POST_SECURITY_ANSWER_START : 'POST_SECURITY_ANSWER_START',
    POST_SECURITY_ANSWER_ERROR : 'POST_SECURITY_ANSWER_ERROR'
};

function reducer(state, { type, payload }) {
    switch (type) {
        case actions.GET_USER_DETAILS:
            return {
                ...state,
                lookUpUserDetails: payload,
                formSubmitted: true
            }; 
        case actions.POST_SECURITY_ANSWER_START:
            return {
                ...state,
                userResponse: payload,
        };    
        case actions.POST_SECURITY_ANSWER_SUCCESS:
            return {
                ...state,
                userResponse: payload,
            };  
        case actions.POST_SECURITY_ANSWER_ERROR:
            return {
                ...state,
                userResponse: payload,
            }; 
        case actions.RESET_FORM:
            return {
                ...state,
                lookUpUserDetails: null,
                formSubmitted: false
            };      
        default:
            return state;
    }
}

export default () => {
    const [data, dispatch] = useReducer(reducer, {
        lookUpUserDetails: undefined,
        formSubmitted:false,
        userResponse:undefined
    });

    const getUserSecurityQuestion = async (data : any) => {
        try {
            const res = await api.get(
                global.__ENV__.PRODUCTION
                    ? configs.endpoints.GET_USER_SECURITY_DETAILS+'/'+data.phonenumber+'/'+data.lastname
                    : configs.endpoints.GET_USER_SECURITY_DETAILS,
            );
            if (res.data) {
                dispatch({ type: actions.GET_USER_DETAILS, payload: res.data });
            }
        } catch (e) {
            dispatch({ type: actions.GET_USER_DETAILS, payload: [] });
        }
    };

    const postSecurityAnswer = async (data : any) => {
        dispatch({ type: actions.POST_SECURITY_ANSWER_START, payload: {}});
        api.post(
            configs.endpoints.GET_USER_SECURITY_DETAILS+'/validate', data
        ).then(response => {
            dispatch({ type: actions.POST_SECURITY_ANSWER_SUCCESS, payload: response.data });
        })
            .catch((error) => {
                dispatch({ type: actions.POST_SECURITY_ANSWER_ERROR, payload: error });
            });
    };

    const resetForm = async () => {
        dispatch({ type: actions.RESET_FORM, payload: null });
    };

    return {
        ...data,
        getUserSecurityQuestion: (data) => {
            getUserSecurityQuestion(data);
        },
        postSecurityAnswer: (data) => {
            postSecurityAnswer(data);
        },
        resetForm: () => {
            resetForm();
        }
    };
};